<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100 mt-4 md-small-size-100">
            <md-card-content>
                <h4>{{title}}</h4>
                <md-table v-if="takeon!==null">

                        <row-item-view label="Takeon Number" :value="takeon.takeon_number"></row-item-view>
                        <row-item-view label="Shift"
                                       :value="takeon.shift?takeon.shift.name:'Shift Name Here'"></row-item-view>
                        <row-item-view label="Mda:"
                                       :value="takeon.schedule?takeon.schedule.start_time+' Mpaka '+takeon.schedule.end_time
                                       :'Shift Time Here'"></row-item-view>
                        <row-item-view label="Work point"
                                       :value="takeon.workplace?takeon.workplace.name:'Work point Name Here'"></row-item-view>
                        <row-item-view label="Activity"
                                       :value="takeon.activity?takeon.activity.name:'Activity Name Here'"></row-item-view>
                    <tbody v-if="full">
                        <row-item-view label="Supervisor Checkin:"
                                       :value="takeon.checkinSupervisor?takeon.checkinSupervisor.full_name:'Supervisor Name Here'"></row-item-view>
                        <row-item-view label="Supervisor Checkin At:"
                                       :value="takeon.checkinSupervisor?takeon.checkinSupervisor.checkin_at:'Supervisor Name Here'"></row-item-view>
                        <row-item-view label="Supervisor Checkout:"
                                       :value="takeon.checkoutSupervisor?takeon.checkoutSupervisor.full_name:'Supervisor Checkout Name Here'"></row-item-view>
                        <row-item-view label="Supervisor Checkout At:"
                                       :value="takeon.checkoutSupervisor?takeon.checkoutSupervisor.checkin_at:'Supervisor Checkout Time Here'"></row-item-view>
                    </tbody>
                </md-table>
                <md-table v-else>
                    <row-item-view label="No Takeon Available" :value="'No '+title+' Available'"></row-item-view>
                </md-table>
            </md-card-content>
        </div>
    </div>
</template>

<script>
import RowItemView from '../../../components/Inputs/RowItemView';

export default {
    name: 'LabourerTakeonCard',
    components: { RowItemView },
    props: {
        takeon: { type: Object },
        full: { type: Boolean, default: false },
        title: { type: String, default: '' }
    }
};
</script>

<style scoped>

</style>
